import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ConnectivityEffects } from './connectivity.effects';
import { connectivityReducer } from './connectivity.reducer';
import { IConnectivityFeature } from './connectivity.feature.state';
import { nameof } from '@symphony-solo/shared/utils/src';
import { ConnectivityFacade } from './connectivity.facade';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IConnectivityFeature>('connectivityFeature'), connectivityReducer),
    EffectsModule.forFeature([ConnectivityEffects]),
  ],
  providers: [ConnectivityFacade],
})
export class ConnectivityStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: ConnectivityStateModule
  ) {
    if (parentModule) {
      throw new Error('ConnectivityStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
